import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

const GRADIENTS = [
  { id: 'gradient-1', name: 'Azul-Roxo', class: 'bg-gradient-to-br from-blue-500 to-purple-600' },
  { id: 'gradient-2', name: 'Rosa-Vermelho', class: 'bg-gradient-to-br from-pink-500 to-rose-600' },
  { id: 'gradient-3', name: 'Verde-Azul', class: 'bg-gradient-to-br from-green-500 to-teal-600' },
  { id: 'gradient-4', name: 'Laranja-Vermelho', class: 'bg-gradient-to-br from-orange-500 to-red-600' },
  { id: 'gradient-5', name: 'Índigo-Azul', class: 'bg-gradient-to-br from-indigo-500 to-blue-600' },
  { id: 'gradient-6', name: 'Roxo-Rosa', class: 'bg-gradient-to-br from-purple-500 to-pink-600' },
];

interface GradientSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

export function GradientSelector({ value, onChange }: GradientSelectorProps) {
  return (
    <div className="space-y-2">
      <Label>Cor da Capa</Label>
      <div className="grid grid-cols-3 gap-3">
        {GRADIENTS.map((gradient) => (
          <button
            key={gradient.id}
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onChange(gradient.id);
            }}
            className={cn(
              "h-16 rounded-lg transition-all",
              gradient.class,
              value === gradient.id
                ? "ring-2 ring-primary ring-offset-2 scale-105"
                : "hover:scale-105 opacity-80 hover:opacity-100"
            )}
            title={gradient.name}
          />
        ))}
      </div>
    </div>
  );
}
